import React from 'react';
import ReactSVG from 'react-svg';

import iconWeb from '../img/icon-website.svg';
import iconLinkedIn from '../img/icon-linkedin.svg';
import iconGitHub from '../img/icon-github.svg';
import iconMedium from '../img/icon-medium.svg';
import iconStackOverflow from '../img/icon-stackoverflow.svg';
import iconBehance from '../img/icon-behance.svg';
import iconUplabs from '../img/icon-uplabs.svg';
import iconDribbble from '../img/icon-dribbble.svg';
import iconGitlab from '../img/icon-gitlab.svg';

const renderIcon = (url) => {
  if (url.includes('linkedin.com')) {
    return <ReactSVG src={iconLinkedIn} />;
  } else if (url.includes('github.com')) {
    return <ReactSVG src={iconGitHub} />;
  } else if (url.includes('medium.com')) {
    return <ReactSVG src={iconMedium} />;
  } else if (url.includes('stackoverflow.com')) {
    return <ReactSVG src={iconStackOverflow} />;
  } else if (url.includes('behance.net')) {
    return <ReactSVG src={iconBehance} />;
  } else if (url.includes('uplabs.com')) {
    return <ReactSVG src={iconUplabs} />;
  } else if (url.includes('dribbble.com')) {
    return <ReactSVG src={iconDribbble} />;
  } else if (url.includes('gitlab.com')) {
    return <ReactSVG src={iconGitlab} />;
  }

  return <ReactSVG src={iconWeb} />;
};

const renderUrls = (urls) =>
  urls.map((url, i) => (
    <li key={i} className="o-list-inline__item u-margin-right-tiny">
      <a href={url} rel="noopener noreferrer" target="_blank">
        {renderIcon(url)}
      </a>
    </li>
  ));

const UrlsList = ({ urls, className = '' }) => (
  <ul className={`o-list-inline ${className}`}>{renderUrls(urls)}</ul>
);

export default UrlsList;



// WEBPACK FOOTER //
// ./src/user/UrlsList.js